// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2315":"ucare-panel-chunk","3923":"ucare-widget-chunk"}[chunkId] || chunkId) + ".bundle.js";
};